import React, {Component} from 'react'
import {UserNav, SimpleFilter, TeamCard} from './../../../components'
import Router from './../../../services/Router'
import { TeamStyle } from '../../../styles'
import { withLoader } from '../../../hoc/withLoader'

class Team extends Component {
  state = {
    categories: [],
    users: [],
    userReady: false,
    filter: '',
  }

  componentDidMount() {
   this.update()
  }

  componentWillReceiveProps({ data, location }) {
    if (this.props.location.pathname !== location.pathname) {
      this.setState({ userReady: false })
      this.timer = setTimeout(() => {
        this.update()
      }, 400)
    }

    if ( data !== this.props.data) {
      const nCategories = []
      let i = 0
      data.categories.map((cat, index) => {
        nCategories.push({ slug: cat.name.toLowerCase(), label: cat.name})
        i = index
        if (i === data.categories.length - 1 ) {
          this.setState({
            categories: nCategories,
            users: data.members,
          })
        }
      })
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  update = () => {
    this.setState({
      filter: this.props.match.params.filter ? this.props.match.params.filter : '',
      userReady: true,
    })
  }


  render () {
    const { isReady } = this.props
    const {categories, users, userReady, filter} = this.state
    return (
      <div className={`team ${TeamStyle(userReady)}`}>
        <UserNav />
        <div className={`transition ${isReady ? 'transition--ready' : ''}`}>
          <div className="team-filter">
            <SimpleFilter filters={categories} parentPath={Router.team.exactPath} />
          </div>
          <div className="fluid">
            <div className="teams-inner">
              <h2> { filter !== '' ? filter : "Sales Marketing" } </h2>
              <div className="flex">
                {
                  users
                    .filter((user) => ( filter === user.team_category.toLowerCase() || (filter === '' && user.team_category === 'Sales Marketing')) )
                    .map((user, index) => (
                      <TeamCard user={user} key={index} />
                    ))
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withLoader(Team, '/brand/company/team', false, false)



// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Team.js